<template>
  <div>
    <v-btn color="primary" large :to="{ name: 'users.create' }" class="mb-4">{{ $t('Create user') }}</v-btn>
    <datatable ref="usersDatatable" :config="configDatatale"/>
    <dialog-delete ref="dialogDelete" @yes="deleteItem"/>
  </div>
</template>

<script>
import Datatable from '@/components/Datatable'
import DialogDelete from '@/components/DialogDelete'
import { utcToLocal } from '@utils'
import { call } from 'vuex-pathify'

export default {
  name: 'UserIndex',
  components: {
    Datatable,
    DialogDelete
  },
  data: (vm) => ({
    configDatatale: {
      url: '/api/admin/users/datatable',
      operations: [
        {
          color: 'warning',
          icon: 'mdi-pencil',
          text: 'Edit',
          method: function (item) {
            vm.$router.push({ name: 'users.edit', params: { id: item.id } })
          }
        },
        {
          color: 'error',
          icon: 'mdi-delete',
          text: 'Delete',
          method: function (item) {
            vm.$refs.dialogDelete.confirm(item)
          }
        }
      ],
      columns: [
        {
          text: 'ID',
          data: 'id',
          name: 'id',
          searchable: true,
          orderable: true
        },
        {
          text: vm.$t('Avatar'),
          data: 'avatar',
          name: 'avatar',
          searchable: false,
          orderable: false,
          html: true,
          render: function (item, column) {
            if (!item) {
              return null
            }
            return `<img src="${item.avatar_source}" class="rounded-circle" style="max-width: 50px"/>`
          }
        },
        {
          text: vm.$t('Username'),
          data: 'username',
          name: 'username',
          searchable: true
        },
        {
          text: vm.$t('Name'),
          data: 'name',
          name: 'name',
          html: true,
          render: function (item, column) {
            if (!item) {
              return null
            }
            return `<span>${item[column]}</span>`
          }
        },
        {
          text: vm.$t('Gender'),
          data: 'gender',
          name: 'gender',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return vm.__attr(item[column])
          }
        },
        {
          text: vm.$t('Role'),
          data: 'role',
          name: 'role',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return vm.__attr(item[column])
          }
        },
        {
          text: vm.$t('Mobile'),
          data: 'mobile',
          name: 'mobile'
        },
        {
          text: vm.$t('Created at'),
          data: 'created_at',
          name: 'created_at',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return utcToLocal(item[column], 'DD/MM/YYYY HH:mm')
          }
        },
        {
          text: vm.$t('Operations'),
          data: '_operations',
          name: null,
          searchable: false,
          orderable: false,
          search: {
            value: null,
            regex: false
          }
        }
      ],
      setting: {
        displaySearchInput: true,
        operationStyle: 'default'
      }
    }
  }),

  methods: {
    handleDelete: call('user/delete'),
    loading: call('app/setLoading'),
    showNotify: call('notify/show'),

    async deleteItem(item) {
      this.loading(true)
      const res = await this.handleDelete(item.id)
      this.loading(false)
      if (res) {
        const { message } = res
        this.showNotify(message)
        this.$refs.usersDatatable.fetchData()
      } else {
        this.showNotify(this.$t('Something went wrong.'))
      }
    }
  }
}
</script>
